import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { api, formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

/** Forces invited users to set a new password before using the app. */
export default function ChangePasswordGate({ children }) {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user?.must_change_password) setOpen(true); }, [user?.must_change_password]);

  async function submit(e) {
    e.preventDefault();
    if (pwd.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pwd !== pwd2) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pwd });
      await refresh();
      toast.success("Password updated");
      setOpen(false); setPwd(""); setPwd2("");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  }

  if (!open) return children;
  return (
    <>
      {children}
      <Dialog open={open} onOpenChange={() => {}}>
        <DialogContent className="sm:max-w-md" data-testid="must-change-password">
          <DialogHeader>
            <DialogTitle className="font-serif-display flex items-center gap-2"><ShieldAlert size={20} className="text-[#C05640]" /> Set a new password</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-stone-600 mt-2">You're using a temporary password. Please choose a new one to continue.</p>
          <form onSubmit={submit} className="space-y-3 mt-3">
            <div><Label>New password</Label><Input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="new-pwd" className="h-11 mt-1.5" /></div>
            <div><Label>Confirm password</Label><Input type="password" required value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="new-pwd2" className="h-11 mt-1.5" /></div>
            <Button type="submit" disabled={busy} data-testid="save-new-pwd"
              className="w-full h-11 rounded-full bg-[#C05640] hover:bg-[#A54734]">{busy ? "Saving…" : "Save password"}</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
